// extracted by mini-css-extract-plugin
module.exports = {"labelWrapper":"style__labelWrapper__24H8w","labelMessage":"style__labelMessage__VFMIq"};